import { defineMessage } from '../../services/localization';

export const messages = {
    selectFileButton: defineMessage('upload_file'),
    dragFileMessage: defineMessage('drag_drop_to_upload'),
    acceptedExtensions: defineMessage('accepted_file_types'),
    maxSizeText: defineMessage('max_maxsize'),
    hint: defineMessage('release_the_mouse_button_and_drop_the_file'),
    file: defineMessage('file'),
    files: defineMessage('files'),
};

export const errorMessages = {
    fileInvalidType: defineMessage('invalid_file_type'),
    fileTooLarge: defineMessage('file_size_more_than_maxsize'),
    fileTooSmall: defineMessage('file_size_less_than_maxsize'),
    tooManyFiles: defineMessage('only_one_file_can_be_uploaded'),
    tooManyFilesInList: defineMessage('sorry_only_maxfilesinli_n_be_uploaded_at_a_time'),
    duplicateFile: defineMessage('please_reupload_the_fil_e_name_is_already_added'),
    unknownError: defineMessage('unknown_error'),
};
